import Link, { GeneralLinkProps } from './Link';

export type { GeneralLinkProps };
export default Link;
